import classnames from 'classnames/bind'
import React from 'react'

import Cta, { CtaProps } from '~/components/Cta'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface EditoPushProps {
  className?: string
  title?: RichTextBlock[]
  primaryCta?: CtaProps
  secondaryCta?: CtaProps
  text?: RichTextBlock[]
}
/**
 * Edito push slice
 * @param props
 * @returns Slice
 */
function EditoPush({
  className,
  title,
  text,
  primaryCta,
  secondaryCta,
}: EditoPushProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({ textPreset: 'title-content-section' })

  return (
    <section className={cx(css.EditoPush, className, gridStyle)}>
      <div className={css.content}>
        {title && (
          <RichText className={cx(titleStyle, css.title)} render={title} />
        )}

        <div className={css.ctas}>
          {primaryCta && <Cta className={css.cta} {...primaryCta} />}
          {secondaryCta && <Cta className={css.cta} {...secondaryCta} />}
        </div>
      </div>
    </section>
  )
}

EditoPush.defaultProps = {}

export default EditoPush
